import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  TERMS_LINKS_GROUP_VARIANT,
  TermsLinksGroup,
} from 'components/TermsLinksGroup'
import { TrustPilotBannerVariant1 } from 'components/TrustpilotBanner'

import { useCohortInfo } from 'hooks/useCohortInfo'
import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'
import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import financialImage from 'assets/images/financial-potential-image.webp'

import { Language } from 'root-constants'

import { StyledStartQuizAyah as S } from './StartQuizAyah.styles'
import {
  AYAH_99_TEXT_CONTEXT_BY_VARIANT,
  COHORTS_WITHOUT_TRUSTPILOT_BANNER,
} from './constants'

export const StartQuizAyah: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
  isFirstPage,
}) => {
  const { t } = useTranslation()
  const { cohortToUse } = useCohortInfo()
  const { ayah99FinanceFirstScreenVariant } = useExperimentalFeatures()
  const context =
    AYAH_99_TEXT_CONTEXT_BY_VARIANT[ayah99FinanceFirstScreenVariant]

  const shouldShowTrustPilotBanner =
    !COHORTS_WITHOUT_TRUSTPILOT_BANNER.includes(cohortToUse)

  const handleContinue = useNextStep({
    pageId,
    question: t('onboarding.startQuizAyah.title', {
      lng: Language.EN,
      context,
    }),
    nextPagePath,
    isFirstPage,
  })

  return (
    <S.Wrapper>
      {shouldShowTrustPilotBanner && <TrustPilotBannerVariant1 />}

      <S.Title>{t('onboarding.startQuizAyah.title', { context })}</S.Title>
      <S.Subtitle>
        {t('onboarding.startQuizAyah.subtitle', { context })}
      </S.Subtitle>
      <S.Note>{t('onboarding.startQuizAyah.3minQuiz')}</S.Note>

      <S.Image src={financialImage} />

      <S.Button type="button" onClick={() => handleContinue('')}>
        {t`actions.startMyQuiz`}
      </S.Button>

      <S.TermsSection>
        <TermsLinksGroup
          titleKey="commonComponents.termsGenderTitle"
          variant={TERMS_LINKS_GROUP_VARIANT.DARK}
        />

        <S.TermsNote>{t('commonComponents.termsNote')}</S.TermsNote>
      </S.TermsSection>
    </S.Wrapper>
  )
}
